import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const AccountDeletion = () => {

    const toast = useRef(null)
    const [deleteAccounts, setDeleteAccounts] = useState([])

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(() => {
        getDeleteAccounts()
    }, [])

    const getDeleteAccounts = () => {
        ApiHelper.get(API_ENDPOINTS.ACCOUNT_DELETION).then((res) => {
            if (res.status === 200) {
                setDeleteAccounts(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.status != 'pending' ? 'bg-success' : 'bg-warning'}`}> {rowData.status} </span>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Account Deletion </p></span></h4>
                            {/* <Link class="btn btn-primary" to={'/admin-users/add'} >Add New User</Link> */}
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={deleteAccounts} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Phone Number' field='userMobileNumber' />
                                            <Column sortable header='Status' body={statusBodyTemplate} />
                                            <Column sortable header='Request Raised On' field='createdAt' body={(rowData) => {
                                                const date = new Date(rowData.createdAt);
                                                return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                            }} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AccountDeletion
